import { APPLY_EVENTS } from '../../constants/events';

export const updateApply = (apply = {}) => ({
	type: APPLY_EVENTS.UPDATE_APPLY,
	payload: apply
});

export const openApplyForm = (job) => ({
	type: APPLY_EVENTS.UPDATE_APPLY,
	payload: { step: 1 , job }
});

export const changeApplyStep = (step) => ({
	type: APPLY_EVENTS.UPDATE_APPLY,
	payload: { step }
});

export const clearDirectApplyAdId = () => ({
	type: APPLY_EVENTS.UPDATE_APPLY,
	payload: { directApplyAdId: null }
});

export const toggleCallUnlockCandidateBuyOptions = show => ({
  type: APPLY_EVENTS.TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS,
  payload: { showCallUnlockBuyOptions: show }
});

export const applyAttributeChange = (attributes) => ({
  type: APPLY_EVENTS.FORM_FIELD_CHANGE,
  payload: attributes
});

export const checkWhatsappNotificationOtp = (optStatus) => ({
	type :APPLY_EVENTS.WHATSAPP_NOTIFICATION,
	payload : optStatus
});

export const toggleSkipApplyInitiatedFlag = value => ({
  type: APPLY_EVENTS.TOGGLE_SKIP_APPLY_FLAG,
  payload: { isSkipApplyInitiated: value }
});

export const toggleQuickApplyInitiatedFlag = value => ({
  type: APPLY_EVENTS.TOGGLE_QUICK_APPLY_FLAG,
  payload: { isQuickApplyInitiated: value }
});

export const setUtmParameters = utmParameters => ({
  type: APPLY_EVENTS.SET_UTM_PARAMETERS,
  payload: utmParameters
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/ApplyActions/index.js